// winner test script for no cart vs cart drawer
document.body.classList.add("c-cartDrawerTest");
//open cart drawer for var a mobile
function openCartDrawerForVarA(){
  document.querySelectorAll('header-drawer a#cart-icon-bubble').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('a#cart-icon-bubble')[0].click();
    });
  });
}
openCartDrawerForVarA();
// winner test script for no cart vs cart drawer


document.addEventListener('DOMContentLoaded', (event) => {
  const trustedSite = document.querySelector('.trusted_site');
  if (trustedSite) {
    trustedSite.addEventListener('click', function (e) {
      e.preventDefault();
      const trustedImage = document.querySelector('#trustedsite-tm-image');
      if (trustedImage) trustedImage.click();
    });
  }

  // Check for modal and button existence
  function setupModal(modalId, buttonId) {
    const openButton = document.querySelector(buttonId);
    const modal = document.querySelector(`#${modalId}`);
    const overlay = document.querySelector('.modal-overlay');
    const body = document.body;

    if (openButton && modal && overlay) {
      openButton.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.remove('mfp-hide');
        overlay.style.display = 'block';
        body.classList.add('model_open');
      });

      const closeModalButton = modal.querySelector('.closeModal');
      if (closeModalButton) {
        closeModalButton.addEventListener('click', function () {
          closeModal(modal, overlay, body);
        });
      }

      overlay.addEventListener('click', function () {
        closeModal(modal, overlay, body);
      });
    }
  }

  function closeModal(modal, overlay, body) {
    modal.classList.add('mfp-hide');
    overlay.style.display = 'none';
    body.classList.remove('model_open');
  }

  // Safely setup modals
  setupModal('shipping-selector-form', '#shipping-selector-btn');
  setupModal('fitment-form_model', 'a[href="#help-fitment-form"]');

  // Observe cart changes only if the bubble exists
  const cartBubble = document.querySelector('#cart-icon-bubble');
  if (cartBubble) {
    const mutationCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const tabletCount = document.querySelector('.tablet_count');
          if (tabletCount && cartBubble.querySelector('.cart_total')) {
            tabletCount.textContent = cartBubble.querySelector('.cart_total').textContent;
          }
          if(document.querySelector('.total-item') && cartBubble.querySelector('.cart_total')){
            document.querySelector('.total-item').textContent = cartBubble.querySelector('.cart_total').textContent;
          } else {
            document.querySelector('.total-item').textContent = 0;
            document.querySelector('.conitnue-shipping').classList.add("hidden");
            document.querySelector('.c-cart-title').classList.add("hidden");
            document.querySelector('.checkout_wrapper').classList.add("hidden");
            document.querySelector('.c-cart_reccomendated').classList.add("hidden");
            document.querySelector('.c-cart_details').classList.add("hidden");
          }
        }
      }
    };

    const observer = new MutationObserver(mutationCallback);

    const config = {
      childList: true,
      attributes: true,
    };

    observer.observe(cartBubble, config);
  }

  // Account modal handling
  const userAccount = document.querySelector('.userAccount');
  if (userAccount) {
    userAccount.addEventListener('click', function (e) {
      e.preventDefault();
      const userAccountContainer = this.parentElement.querySelector('.user_account-container');
      if (userAccountContainer) {
        userAccountContainer.style.display = 'block';
      }
      e.stopPropagation();
    });
  }

  document.addEventListener('click', function () {
    const popup = document.querySelector('.user_account-container');
    if (popup) {
      popup.style.display = 'none';
    }
  });

  // scroll to review section
  const badge = document.querySelector('.stamped-main-badge');
  const targetSection = document.querySelector('#stamped-main-widget');

  if (badge && targetSection) {
    badge.addEventListener('click', (e) => {
      e.preventDefault();
      targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});

if (document.querySelector('#shipping-selector-btn1')){
  document.querySelector('#shipping-selector-btn1').addEventListener('click',function(){
    document.querySelector('#shipping-selector-btn').click();
  })
}

// Estimated shipping date component logic
function moveEstDateComponent() {
  const estDateEl = document.querySelector('.Estdate_Container');
  const targetEl = document.querySelector('.product-custom_images');
  const originalWrapper = document.querySelector('.original-estdate-wrapper');

  if (!estDateEl || !targetEl || !originalWrapper) return;

  if (window.innerWidth > 991) {
    targetEl.insertAdjacentElement('afterend', estDateEl);
  } else {
    originalWrapper.appendChild(estDateEl);
  }
}

window.addEventListener('DOMContentLoaded', moveEstDateComponent);
window.addEventListener('resize', moveEstDateComponent);


function EstDate_isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

function EstDate_addBusinessDays(startDate, days) {
  const date = new Date(startDate); // Clone to avoid mutation
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    if (!EstDate_isWeekend(date)) {
      added++;
    }
  }
  return date;
}

function EstDate_formatDate(date) {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function EstDate_getShippingBaseDate() {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay();

  let base = new Date(now);
  const isAfterCutoff = hour >= 17;

  if (day === 6 || day === 0 || (day === 5 && isAfterCutoff)) {
    const daysUntilMonday = (8 - day) % 7;
    base.setDate(base.getDate() + daysUntilMonday);
  } else if (isAfterCutoff) {
    base = EstDate_addBusinessDays(base, 1);
  }

  return base;
}

function EstDate_getDeliveryRange() {
  const shipDate = EstDate_getShippingBaseDate();
  const deliveryStart = EstDate_addBusinessDays(new Date(shipDate), 3);
  const deliveryEnd = EstDate_addBusinessDays(new Date(shipDate), 4);
  return `${EstDate_formatDate(deliveryStart)} - ${EstDate_formatDate(deliveryEnd)}`;
}

// Reusable function to update delivery dates - can be called anytime
function updateEstDateDeliveryDates() {
  const elements = document.querySelectorAll('.EstDate_delivery-dates');
  elements.forEach(el => {
    // Only update if the element is empty or doesn't have content yet
    if (!el.textContent.trim() || !el.querySelector('.Est_Date_range')) {
      el.innerHTML = `<span class="Est_Date_text">Arrives between</span> <span class="Est_Date_range"><strong>${EstDate_getDeliveryRange()}</strong></span>`;
    }
  });
}

// Initial update on page load
document.addEventListener('DOMContentLoaded', () => {
  updateEstDateDeliveryDates();
  
  // Use MutationObserver to watch for dynamically added EstDate elements (like in modals)
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node or its children contain EstDate elements
          if (node.classList?.contains('EstDate_delivery-dates') || 
              node.querySelector?.('.EstDate_delivery-dates') ||
              (node.querySelector && node.querySelector('[class*="EstDate"]'))) {
            shouldUpdate = true;
          }
        }
      });
    });
    if (shouldUpdate) {
      // Small delay to ensure DOM is fully updated
      setTimeout(() => {
        updateEstDateDeliveryDates();
      }, 100);
    }
  });

  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also listen for modal open events (for quick-add modals)
  document.addEventListener('click', (e) => {
    if (e.target.closest('quick-add-modal') || e.target.closest('[data-modal]')) {
      setTimeout(() => {
        updateEstDateDeliveryDates();
      }, 500);
    }
  });
});

// Initialize Swiper for product cards
document.addEventListener('DOMContentLoaded', function() {
  // Check if Swiper is available
  if (typeof Swiper !== 'undefined') {
    // Initialize all product card swipers
    const productCardSwipers = document.querySelectorAll('.c-product-card-swiper');
    
    productCardSwipers.forEach((swiperEl, index) => {
      // Only initialize if there are multiple slides
      const slides = swiperEl.querySelectorAll('.swiper-slide');
      if (slides.length > 1) {
        // Create pagination element if it doesn't exist
        let paginationEl = swiperEl.querySelector('.swiper-pagination');
        if (!paginationEl) {
          paginationEl = document.createElement('div');
          paginationEl.className = 'swiper-pagination';
          swiperEl.appendChild(paginationEl);
        }
        
        const nextEl = swiperEl.querySelector('.swiper-button-next');
        const prevEl = swiperEl.querySelector('.swiper-button-prev');

        const swiperConfig = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          pagination: {
            el: paginationEl,
            clickable: true,
          }
        };

        // Add navigation arrows if present
        if (nextEl || prevEl) {
          swiperConfig.navigation = {};
          if (nextEl) swiperConfig.navigation.nextEl = nextEl;
          if (prevEl) swiperConfig.navigation.prevEl = prevEl;
        }

        new Swiper(swiperEl, swiperConfig);
      }
    });
  }
});